import { render, staticRenderFns } from "./SqlDropdown.vue?vue&type=template&id=821ff500&scoped=true&"
import script from "./SqlDropdown.vue?vue&type=script&lang=js&"
export * from "./SqlDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SqlDropdown.vue?vue&type=style&index=0&id=821ff500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ff500",
  null
  
)

export default component.exports